if(!customElements.get('wlsn-comparison-table')) {
  class WLSNComparisonTable extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        slider: 'js-wlsn-comparison-table-slider',
        nextButton: 'js-wlsn-slider-next',
        prevButton: 'js-wlsn-slider-prev',
        pagination: 'js-wlsn-slider-pagination',
        hidden: 'hidden',
        navigation: 'js-slider-navigation',
      }

      this._swiperInstance = null;
    }

    /**
     * Get DOM elements
     * @returns {object} - Object containing DOM element references
     */
    get elements() {
      return {
        slider: this.querySelector(`.js-wlsn-comparison-table-slider`),
        nextButton: this.querySelector(`.${this.classes.nextButton}`),
        prevButton: this.querySelector(`.${this.classes.prevButton}`),
        pagination: this.querySelector(`.${this.classes.pagination}`),
      };
    }

    connectedCallback() {
      this.initSlider();
    }

    disconnectedCallback() {
      if (this._swiperInstance) this._swiperInstance.destroy(true, true);
    }
    /**
     * Initialize the main slider
     * @returns {void}
    */
    initSlider() {
      const { slider } = this.elements;
      if (!slider) return;

      const slides = slider.querySelectorAll('.wlsn-slider__slide');
      if (slides.length) slides[slides.length - 1].classList.add('wlsn-slider__slide--last');

      const slidesPerViewT = parseInt(this.dataset.slidesPerViewT) || 2;
      const slidesPerViewD = parseInt(this.dataset.slidesPerViewD) || 2;

      const mainConfig = {
        loop: false,
        speed: 500,
        spaceBetween: 0,
        grabCursor: true,
        slidesPerView: 'auto',
        resizeObserver: false,
        navigation: {
          nextEl: this.elements.nextButton,
          prevEl: this.elements.prevButton,
        },
        pagination: {
          el: this.elements.pagination,
          clickable: true,
          enabled: true,
          type: 'progressbar',
        },
        breakpoints: {
          768: {
            slidesPerView: slidesPerViewT,
          },
          1024: {
            slidesPerView: slidesPerViewD,
          },
        }
      };

      const navigation = this.querySelector(`.${this.classes.navigation}`);
      mainConfig.on = {
        init: (swiper) => {
          if (navigation && !swiper.isLocked) navigation.classList.remove(this.classes.hidden);
          this.classList.toggle('is-at-end', swiper.activeIndex === swiper.slides.length - 1);
        },
        slideChangeTransitionStart: (swiper) => {
          this.style.setProperty('--comparison-table-transition-duration', `${swiper.params.speed}ms`);
          this.classList.toggle('is-at-end', swiper.activeIndex === swiper.slides.length - 1);
        },
        slideChangeTransitionEnd: (swiper) => {
          this.classList.toggle('is-at-end', swiper.activeIndex === swiper.slides.length - 1);
        },
        fromEdge: () => {
          this.classList.remove('is-at-end');
        },
        lock: () => {
          if (navigation) navigation.classList.add(this.classes.hidden);
        },
        unlock: () => {
          if (navigation) navigation.classList.remove(this.classes.hidden);
        },
      };

      this._swiperInstance = new Swiper(slider, mainConfig);
    }
  }

  customElements.define('wlsn-comparison-table', WLSNComparisonTable);
}
